import React from 'react';
import { ComponentsContext } from '../../../../contexts/componentsContext';
import PhoneInput from 'react-phone-number-input';
import { Input } from '../../../../flayr-components/Input/Input';

interface IMobileInputProps {
  value?: string;
  onChange?: (e: any) => void;
}

const MobileInput: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<IMobileInputProps>>
> = ({ value, onChange }) => {
  const { phoneInput } = React.useContext(ComponentsContext);

  function handlePhoneInputChange(e) {
    onChange?.({ target: { name: 'mobile', value: e } });
  }
  return (
    <div>
      <PhoneInput
        className="text-gray-700"
        defaultCountry={phoneInput?.defaultCountry as any}
        placeholder="Enter your mobile"
        name="mobile"
        inputComponent={Input}
        onChange={handlePhoneInputChange}
        value={value}
        numberInputProps={{
          size: 'lg',
          validation: ['required'],
        }}
      />
    </div>
  );
};
export default MobileInput;
